import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import SingleItem from "./SingleItem";
import axios from "axios";
import { RotatingSquare } from "react-loader-spinner";
import CustomPagination from "../../CustomPagination/CustomPagination";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
import PriceUpdateModal from "./PriceUpdateModal";
import TimeAddModal from "./TimeAddModal/TimeAddModal";

const NFTLists = () => {
  const { authUser } = useContext(AuthContext);

  // view data

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [paginateData, setPaginateData] = useState([]);
  const [updateData, setupdateData] = useState([]);

  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/admin/nft/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setPaginateData(data);
        setLoading(false);
      });
  }, [updateData]);

  const handlePage = (event) => {
    try {
      const pageNumber = event?.selected + 1;
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      axios
        .get(
          `https://api.wlfmobile.com/api/admin/nft/view?page=${pageNumber}`,
          config
        )
        .then((response) => {
          setData(response?.data?.data);
          setPaginateData(response?.data);
        })
        .catch((error) => {});
    } catch (error) {
      console.log(error);
    }
  };

  const handleEnableDisabled = (id) => {
    fetch(`https://api.wlfmobile.com/api/admin/nft/enable/disable/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setupdateData(data);
        if (!data?.data?.status) {
          toast.success(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (data?.data?.status) {
          toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((error) => console.log(error));
  };

  const handleDelete = (id) => {
    fetch(`https://api.wlfmobile.com/api/admin/nft/delete/${id}`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setupdateData(data);
         toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        
      })
      .catch((error) => console.log(error));
  };

  // price modal

  const [singleDataId, setSingleDataId] = useState(null);

  const [priceModalshow, setPriceModalshow] = useState(false);

  const handlePriceModalShow = (id) => {
    setSingleDataId(id);
    setPriceModalshow(true);
  };

  // update price

  const [disablePriceBtn, setDisablePriceBtn] = useState(false);

  const handleUpdatePricePlus = (id) => {
    setDisablePriceBtn(id);
    fetch(`https://api.wlfmobile.com/api/admin/nft/price/plus/update/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        toast.success(`${data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setupdateData(data?.data);
        setDisablePriceBtn(null);
      })
      .catch((error) => {
        // console.log(error)
      });
  };

  const handleUpdatePriceMinus = (id) => {
    setDisablePriceBtn(id);
    fetch(`https://api.wlfmobile.com/api/admin/nft/price/minus/update/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        toast.success(`${data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setupdateData(data?.data);
        setDisablePriceBtn(null);
      })
      .catch((error) => {
        // console.log(error)
      });
  };




    const [modalShow, setModalShow] = useState(false);
  const [NewCoinId, setNewCoinId] = useState();

  const HandleTimeFun = (id) => {
    if (id) {
      setModalShow(true);
      setNewCoinId(id);
    }
  };

  if (!authUser?.new_coin) {
    if (authUser?.new_coin === undefined) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <h1>unauthorized</h1>
        </>
      );
    }
  } else {
    if (loading) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
            <h6 className="page-title">NFT List</h6>
            <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
            <Link
              to="/admin/nft/message"
              className="btn btn-sm btn-outline-primary addBtn"
            >
              <i className="fa-solid fa-list-ul me-1"></i>
                Message
            </Link>
              <Link
                to="/admin/nft/add"
                className="btn btn-sm btn-outline-primary addBtn"
              >
                <i className="las la-plus"></i>Add New
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="card b-radius--10 ">
                <div className="card-body p-0">
                  <div className="table-responsive--md  table-responsive">
                    <table className="table table--light style--two mb-0">
                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Symbol</th>
                          <th>Supply Coin</th>
                          <th></th>
                          <th>Default Price</th>
                          <th>limit</th>
                          <th>Expired Time</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length !== 0 ? (
                          data.map((data, index) => {
                            if (data) {
                              return (
                                <SingleItem
                                  data={data}
                                  index={index}
                                  key={data._id}
                                  handleDelete={handleDelete}
                                  handleEnableDisabled={handleEnableDisabled}
                                  paginateData={paginateData}
                                  handlePriceModalShow={handlePriceModalShow}
                                  handleUpdatePricePlus={handleUpdatePricePlus}
                                  disablePriceBtn={disablePriceBtn}
                                  handleUpdatePriceMinus={
                                    handleUpdatePriceMinus
                                  }
                                  HandleTimeFun={HandleTimeFun}
                                ></SingleItem>
                              );
                            }
                          })
                        ) : (
                          <tr>
                            <td
                              className="text-muted text-center"
                              colspan="100%"
                            >
                              Data not found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* paginateLinks */}
                <CustomPagination
                  data={paginateData}
                  handlePage={handlePage}
                ></CustomPagination>
                {/* paginateLinks */}
              </div>
            </div>
          </div>

          {(() => {
            if (priceModalshow) {
              return (
                <PriceUpdateModal
                  singleDataId={singleDataId}
                  setShow={setPriceModalshow}
                  show={priceModalshow}
                  setupdateData={setupdateData}
                ></PriceUpdateModal>
              );
            }
          })()}


           <TimeAddModal
            show={modalShow}
            NewCoinId={NewCoinId}
            setupdateData={setupdateData}
            onHide={() => setModalShow(false)}
          />

        </>
      );
    }
  }
};

export default NFTLists;
